import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import DailyWetSlider from './../../components/DailyWetSlider/DailyWetSlider';
import * as actionTypes from './../../store/actions/dailyWetAction';
import fetchDailyWetAction from './../../store/actions/fetch/fetchDailyWetAction';
import Loader from './../../components/Loader/Loader';
import * as productTypes from "../Products/ProductsValues";
import FeedingAmountProportions from './../../components/FeedingAmount/FeedingAmountProportions';

// Amount
const RELATED_AMOUNT = 0.1; //TODO Check it
const SNACK = 0.1;
const SNACK_BALANCED = 0.2;
const MIN_AMOUNT = 0.1; // Minimal amount of wet and dry
const WHOLE_PACKAGE_OPTION = 9; //Option on the slider related to the whole package/can
/**
 * Daily Wet Slider container
 */
class DailyWet extends Component {

  /**
   * Compare two arrays
   */
  isEqual(a, b)
  {
    // if length is not equal
    if(a.length!==b.length)
      return "False";
    else
    {
      // comparing each element of array
      for(let i=0;i<a.length;i++)
        if(a[i]!==b[i])
          return "False";
      return "True";
    }
  }

  /**
   * Update just if products or DER changed
   */
  shouldComponentUpdate(nextProps, nextState) {
    const {dataDer, selectedProducts} = this.props;
    if (dataDer.der !== nextProps.dataDer.der) {
      return true;
    }
    else if(this.isEqual(selectedProducts, nextProps.selectedProducts)){
      return true;
    }
    return false;
  }

  /**
   * Fetch data
   */
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  /**
   * Should the slider be greyed? Yes if both wet product and dry product are not selected
   */
  greyed() {
    const {selectedProductsData} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let dryAndWet = 0;
    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === productTypes.WET_FOOD || productType === productTypes.DRY_FOOD){
        dryAndWet += 1;
      }
    }
    if(dryAndWet === 2){
      return false;
    }
    else{
      return true;
    }

  }

  /**
   * Return kcal of snack
   */
  getSnackPortion(){
    const {dataDer, selectedProductsData} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let balanced = 0;
    let notBalanced = 0;

    let balancedCount = 0;  // Count how many balanced products we have
    let notBalancedCount = 0;  // Count how many not balanced products we have

    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === productTypes.SNACKS){
        if(product.balanced === "1"){
          balanced = balanced + 1;
          balancedCount++;
        } else{
          notBalanced = notBalanced + 1;
          notBalancedCount++;
        }
      }
    }

    if (balancedCount == 1 && notBalancedCount == 1){
      // We have a balanced and not balanced product, we need to calcualte to 20% with each product making 10%
      return (dataDer.der * SNACK_BALANCED * balanced + dataDer.der * SNACK_BALANCED * notBalanced) / (2);
    }

    if((balanced + notBalanced) > 0){
      return (dataDer.der * SNACK_BALANCED * balanced + dataDer.der * SNACK * notBalanced) / (balanced + notBalanced);
    }
    return 0;
  }

  /**
   * Return kcal of related
   */
  getRelatedPortion(){
    const {dataDer, selectedProductsData} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let related= 0;
    let isHydracare = false;
    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === productTypes.RELATED){
        related = related + 1;
        if(product.label.toLowerCase().includes("hydra")){
          isHydracare = true;
        }
      }
    }
    if(related > 0){
      return {relatedKcal: (dataDer.der * RELATED_AMOUNT), isHydracare};
    }
    return 0;
  }

  /**
   * Return available portions for slider
   */
  getWetAvailablePortions(usedKcal, greyed){

    if(greyed){
      return [];
    }

    const {dataDer, selectedProductsData} = this.props;
    const availableKcal = dataDer.der - usedKcal - dataDer.der * MIN_AMOUNT;
    const selectedProducts = Object.values(selectedProductsData);

    let wetKcalProduct = 0;

    let product = null;
    for (const selectedProduct of selectedProducts) {
      let productType = selectedProduct.types[0];
      if(productType === productTypes.WET_FOOD){
        wetKcalProduct = selectedProduct.energyPerHundred;
        product = selectedProduct;
      }
    }

    const fragments = [
      {'name': '1/8', 'value': 1/8},
      {'name': '1/4', 'value': 1/4},
      {'name': '1/3', 'value': 1/3},
      {'name': '3/8', 'value': 3/8},
      {'name': '1/2', 'value': 1/2},
      {'name': '5/8', 'value': 5/8},
      {'name': '2/3', 'value': 2/3},
      {'name': '3/4', 'value': 3/4},
      {'name': '7/8', 'value': 7/8},
      {'name': '', 'value': 1},
    ];

    let possibilities = [];
    let amount = 0;
    let i = 0;
    let fullPart = 0;

    if(wetKcalProduct <= 0){
      return possibilities;
    }

    let limit = 100;
    let current = 0;

    while(true){
      current++;

      if (current >= limit){
        break;
      }

      let energyPerHundred = parseInt(product.energyPerHundred);
      let packagingGrams = product.packaging[1].replace(/[0-9]/g, '');
      let packagingSize = parseInt(product.packaging[1].replace('g',''));

      if (packagingGrams == "kg"){
        packagingSize = packagingSize * 1000; // Convert kg to grams
      }

      let productEnergyAdjusted = (packagingSize / 100) * energyPerHundred

      amount = (productEnergyAdjusted * fullPart) + (productEnergyAdjusted * fragments[i]['value']);

      // amount =  wetKcalProduct * fullPart + wetKcalProduct * fragments[i]['value'];

      if (amount > availableKcal){
        break;
      }

      // Get text for slider
      let text = "";
      if(fullPart > 0 && fragments[i]['name'] !== ''){
        text = text + fullPart + ' '
      }
      if(fragments[i]['name'] === ''){
        text = text + (fullPart +1);
      }
      text = text + fragments[i]['name'];
      possibilities.push({'text': text, 'amount': amount});
      // reset i
      i = (i + 1) % 10;
      if(i === 0) {
        fullPart += 1;
      }
    }
    return possibilities;
  }

  /**
   * Return kcal, kcal label and name of package of wet food
   */
  getWetPortion(portions, selected, usedKcal){
    const {onSelect, selectedProductsData, dataDer} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let dry = false;
    let wet = false;
    let wetPackage = "";

    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === productTypes.DRY_FOOD){
        dry = true;
      }
      if(productType === productTypes.WET_FOOD){
        wet = true;
        wetPackage = product.packaging[0];
      }
    }

    if(!dry && wet){
      return {
        wetPortion: dataDer.der - usedKcal,
        wetPortionLabel: "",
        wetPackage: wetPackage
      };
    }

    if(selected in portions){
      return {
        wetPortion: portions[selected]['amount'],
        wetPortionLabel: portions[selected]['text'],
        wetPackage: wetPackage
      };
    }
    else if(portions.length === 0){
      return {
        wetPortion: 0,
        wetPortionLabel: '',
        wetPackage: wetPackage
      };
    }
    else{
      const defaultOption = portions.length < 10 ? (portions.length - 1) : WHOLE_PACKAGE_OPTION;
      onSelect(defaultOption);
      return {
        wetPortion: portions[defaultOption]['amount'],
        wetPortionLabel: portions[defaultOption]['text'],
        wetPackage: wetPackage
      };
    }
  }

  /**
   * Return kcal of dry food
   */
  getDryPortion(usedDer){
    const {dataDer, selectedProductsData} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let isDry = false;
    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === productTypes.DRY_FOOD){
        isDry = true;
      }
    }
    if(isDry){
      return dataDer.der - usedDer;
    }
    else{
      return 0;
    }
  }

  /**
   * Get product portions for amount indicator
   */
  getProductPortions(dryPortion, wetPortion, relatedPortion, snackPortion){
    const {dataDer} = this.props;
    const snack = Math.round((snackPortion/dataDer.der)*100);
    const related = Math.round((relatedPortion/dataDer.der)/100);
    const wet = Math.round((wetPortion/dataDer.der)*100);
    let dry = 0;
    if(dryPortion > 0){
      dry = 100 - wet - related - snack;
    }
    const productProportions = [
      {
        width: dry,
        class: "nppe2-fc-type-of-food-bar__red",
      },
      {
        width: wet,
        class: "nppe2-fc-type-of-food-bar__purple",
      },
      {
        width: related,
        class: "nppe2-fc-type-of-food-bar__orange",
      },
      {
        width: snack,
        class: "nppe2-fc-type-of-food-bar__teal",
      },
    ];
    return productProportions;
  }

  /**
   * Get grams of wet or dry product
   *
   * @argument productProportionKcal    The amount of kcal we are calulating the weight for
   * @argument type                     The type of product
   */
  getGrams(productProportionKcal, type){
    const {selectedProductsData} = this.props;
    const selectedProducts = Object.values(selectedProductsData);
    let neededKcal = false;
    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType === type){
        neededKcal = Math.round((productProportionKcal / product.energyPerHundred) * 100);
      }
    }
    if(!neededKcal){
      return "?";
    }

    return neededKcal;
  }

  /**
   * Render
   */
  render() {
    const {
      data, error, pending, selected, readyProducts, availableCategories,
      defaultValues, pendingDer, ready, onSelect, dataProduct, onSetAmounts
    } = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending && readyProducts && !pendingDer) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );

    // Get greyed
    const greyed = this.greyed();

    // Get Snack Portion
    const snackPortion = this.getSnackPortion();

    // Get RelatedPortion
    const {relatedKcal, isHydracare} = this.getRelatedPortion();
    const relatedPortion = isHydracare ? relatedKcal : 0;

    // Get Portions
    const portions = this.getWetAvailablePortions(relatedPortion, greyed);

    // Return slider
    const {wetPortion, wetPortionLabel, wetPackage} = this.getWetPortion(portions, selected, relatedPortion);
    const dryPortion = this.getDryPortion(relatedPortion + wetPortion);

    // Product portions
    const productProportions = this.getProductPortions(dryPortion, wetPortion, relatedPortion, snackPortion);

    // Dry weight
    const dryWeight = this.getGrams(dryPortion, productTypes.DRY_FOOD);

    // Wet weight
    const wetWeight = this.getGrams(wetPortion, productTypes.WET_FOOD);

    // Save values
    onSetAmounts({
      snackKcal: snackPortion,
      relatedKcal: isHydracare ? relatedKcal : 0,
      wetKcal: wetPortion,
      dryKcal: dryPortion,
      wetGrams: wetWeight,
      dryGrams: dryWeight,
      relatedPortion: relatedPortion,
      snackPortion: snackPortion,
      wetPortionLabel: wetPortionLabel,
      wetPackage: wetPackage,
    });

    return (
      <div className='nppe2-fc-daily-wet-slider__wrapper'>
        {error && <span className='nppe2-fc-daily-wet-slider__error'>{error}</span>}
        {!error &&
        <DailyWetSlider
          data={data}
          selected={selected === -1 ? WHOLE_PACKAGE_OPTION : selected}
          selectedLabel={wetPortionLabel}
          portions={portions}
          greyed={greyed}
          maxSelected={portions.length - 1}
          onSelect={onSelect}
          wetPackage={wetPackage}
        />
        }
        {error && <span className='nppe2-fc-daily-wet-slider-feeding-amount__error'>{error}</span>}
        {!error &&
        <FeedingAmountProportions
          productProportions={productProportions}
          data={data}
          dataProduct={dataProduct}
          snackPortion={Math.round(snackPortion)}
          relatedPortion={parseFloat((relatedPortion)).toFixed(2)}
          dryPortion={Math.round(dryPortion)}
          wetPortion={Math.round(wetPortion)}
          dryWeight={dryWeight}
          wetWeight={wetWeight}
          availableCategories={availableCategories}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.dailyWetReducer.selected,
    error: state.dailyWetReducer.error,
    data: state.dailyWetReducer.data,
    pending: state.dailyWetReducer.pending,
    ready: state.dailyWetReducer.ready,
    selectedProducts: state.productsReducer.selected,
    selectedProductsData: state.productsReducer.selectedData,
    readyProducts: state.productsReducer.ready,
    dataDer: state.calculateDerReducer.data,
    pendingDer: state.calculateDerReducer.pending,
    dataProduct: state.productsReducer.data,
    availableCategories: state.productsReducer.availableCategories,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchDailyWetAction
      },
      dispatch,
    ),
    onSelect: (value) => dispatch({
      type: actionTypes.SELECT,
      selected: value,
    }),
    onSetAmounts: (amounts) => dispatch({
      type: actionTypes.SET_AMOUNTS,
      amounts: amounts,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyWet);
